var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonPay',{ref:"pay",attrs:{"user":_vm.user,"wxpay":_vm.wxpay,"probe":_vm.probe,"prepay":_vm.prepay,"title":"去水印特权"},on:{"paid":_vm.afterPaid}})}
var staticRenderFns = []

export { render, staticRenderFns }